import React, {useState} from "react";
import '../TroublesForQuiz.scss';
import DataAnswer from "../DataAnswer/DataAnswer";
import { openViewDeleteInputFormsForTrouble } from "../../troubleslice";
import { setSelectedIdTrouble } from "../../../../Admin/adminSlice";

const DataTrouble = (props) => {


    const { dispatch } = props;
    //RENDER TABLE OF TROUBLES
   
        //let  data =  [{id:23, trouble:"how do it"},{id:47, trouble:"how do it quickly"},{id:48, trouble:"how do it quickly"},{id:49, trouble:"how do it quickly"},{id:67, trouble:"how do it quickly"},];
        const idTrouble = props.idTrouble;
        const handleOnGetAnswerTrouble = (e) => props.onGetAnswerTrouble(e);

            //HANDLE DELETE ANSWER TROUBLE
        const handleDeleteTrouble = (e) => {

        console.log('delete  trouble' );
        //console.log(e.currentTarget.value);
        dispatch(setSelectedIdTrouble(e.currentTarget.value));
        dispatch(openViewDeleteInputFormsForTrouble());
    }
        
        const handleAddAnswer = (e) => props.addAnswer(e);
        const openAnswer = props.openAnswer;


        const item = props.item;

                           
                    // console.log(item.id + " " + item.label);

                        return(
                            <div className="main-tr" key={item.trouble_id}>
                            
                                <div className="tr-style" >
                                    <div className="container">
                                        <div className="index-name">#{item.trouble_id}/{props.countAnswers}</div>
                                        <div className="td-style">
                                        <button className='bigbtn'                     
                                        onClick={props.countAnswers!==0 ? handleOnGetAnswerTrouble : null}
                                        value={item.trouble_id}
                                        >{item.text}</button>
                                        </div>
                                    </div>
                                    <div className='delete'>
                                        <button className='smallbtnDelete' value={item.trouble_id} onClick={handleDeleteTrouble}></button>
                                    
                                    </div>
                                    
                                </div>
                                <div className='addAnswer'>
                                        <button className='addAnswer' value={item.trouble_id} onClick={handleAddAnswer}>Ответить</button>
                                    
                                </div>
                                {(openAnswer && item.trouble_id === idTrouble && props.dataAnswerTroubles.length !== 0) && <DataAnswer
                               
                                dataAnswerTroubles={props.dataAnswerTroubles}
                                troublesData={props.troublesData}
                                dispatch={dispatch}
                                />}
                            </div>   
                            

                            )
                        
                        
                                        
    
};
export default DataTrouble;